const getters = {
  sidebar: state => state.app.sidebar,

  modal: state => state.app.modal,

  language: state => state.app.language,

  hideLogin: state => state.app.LoginCard,

  dashboardWidgetsList: state => state.dashboard.dashboardWidgetsList,

  list8: state => state.dashboard.list8,

  list16: state => state.dashboard.list16,

  projects: state => state.user.projects,

  smtpConfig: state => state.user.currentUser.smtp,

  currentUser: state => state.user.currentUser,

  getGatewaysByProjectId: state => projectId => {
    return state.user.projects.find(project => projectId === project.id).gateways
  },

  userGraphs: state => state.analytics.graphs,

  getGraphByID: (state) => (id) => {

    return state.analytics.graphs.find(graph => graph.id === id);
  },
  getGatewaysByScope: (state, getters) => (scope) => {

    if (scope) {
      if (scope !== 'all') {
        return getters.getGatewaysByProjectId(scope);
      } else {
        let allGateways = [];
        state.user.projects.forEach(project => {
          allGateways = allGateways.concat(project.gateways)
        });
        return allGateways;
      }
    } else {
      return []
    }


  },
  getGatewayDevices: (state, getters) => (project, gateway) => {

    if (gateway && gateway === 'all') {
      let allDevices = [];
      if (project !== 'all') {
        let gateways = state.user.projects.find(project => project === project).gateways;
        gateways.forEach(gateway => {
          allDevices = allDevices.concat(gateway.devices)
        });
        return allDevices
      } else {
        let allGateways = getters.getGatewaysByScope('all');
        console.log(allGateways);
        let devices = [];
        allGateways.forEach(gateway => {
          devices = devices.concat(gateway.devices)
        });
        return devices
      }
    } else if (gateway && gateway !== 'all') {
      let gateways = getters.getGatewaysByScope(project);
      return gateways.find(gatewayItem => gatewayItem.id === gateway).devices
    }

  },

  getSensors: (state, getters) => (project, gatewayId, deviceId) => {
    if (gatewayId && gatewayId !== 'all' && project !== 'all') {

      let gateway = getters.getGatewaysByProjectId(project).find(gatewayItem => gatewayItem.id === gatewayId);

      let allSensor = [];
      allSensor = gateway.sensors;
      if (!deviceId) {
        return allSensor

      } else {
        let devices = getters.getGatewayDevices(project, gatewayId);
        devices.forEach(device => {
          allSensor = allSensor.concat(device.sensors);
        });
        return allSensor
      }

    }

    if (gatewayId && gatewayId === 'all' && project === 'all') {

      let gateways = getters.getGatewaysByScope(project);
      let allSensor = [];
      gateways.forEach(gateway => {
        allSensor = allSensor.concat(gateway.sensors)
      });
      let devices = getters.getGatewayDevices(project, gatewayId);
      if (deviceId) {
        if (deviceId !== 'all') {
          allSensor = allSensor.concat(devices.find(device => device.id === deviceId).sensors);
        } else {
          devices.forEach(device => {
            allSensor = allSensor.concat(device.sensors);
          })
        }
      }

      return allSensor
    }
    if (gatewayId && gatewayId !== 'all' && project === 'all') {
      let gateways = getters.getGatewaysByScope(project);
      let allSensor = [];
      allSensor = gateways.find(gatewayItem => gatewayItem.id === gatewayId).sensors
      let devices = getters.getGatewayDevices(project, gatewayId);
      if (deviceId) {
        if (deviceId !== 'all') {
          allSensor = allSensor.concat(devices.find(device => device.id === deviceId).sensors);
        } else {
          devices.forEach(device => {
            allSensor = allSensor.concat(device.sensors);
          })
        }
      }
      return allSensor
    }
    return []
  },
  getProjectById:(state,getters)=>(id)=>{
    return [state.user.projects.find(project=>project.id)]
},

  getFiltersById: (state) => (id) => {

    let filters = state.analytics.graphFilters.find(item => {
      return item.id === id
    });
    return filters ? filters.filters : []
  },

  getGraphDataById: (state) => (id) => {
    let graphData = state.analytics.graphData.find(item => {
      return item.id === id
    });
    console.log('====>',graphData);
    return graphData ? graphData.data : [];
  },

  constructDataObjectGraph: (state,getters) => (id) => {
    let graph=getters.getGraphByID(id);
    // this might be an issue if we are having multiple copies of the graph data.
    let graphData=getters.getGraphDataById(id);
    let keys=Object.keys(graphData);
    let traces=[];
    keys.forEach(key=>{


    })




  },

  getGraphDataByIdPieChart: (state, getters) => (id) => {

    let filters = getters.getFiltersById(id);
    let graphData = state.analytics.graphData.find(item => {
      return item.id === id
    });
    let graphPlot = [];
    filters.forEach(filter => {
      graphPlot.push({
        name: filter.name,
        type: filter.chart_type,
        values: [null],
        labels: [null],
        marker: {
          color: filter.chart_color
        }

      })
    });
    return graphPlot;
  },


  getGraphFilterById: (state, getters) => ((graphId, index) => {
    console.log("=====>", graphId);
    console.log("=====>", index);

    let graphFilters = getters.getFiltersById(graphId);
    console.log("=====>", graphFilters);

    return graphFilters[index];

  })


};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js